import TextareaAutosize from '@mui/material/TextareaAutosize';
import './inputAutoSize.css';

export default function InputAutoSize(props) {
  const maxLen = 2000;
  return (
    <div>
      <div>
        {props.question.questionNbr}. {props.question.questionDescr}
      </div>
      {props.validationError ? (
        <div>
          <p className="input-autosize-required">* Required</p>
        </div>
      ) : null}
      {props.isQuestionWithAnswer ? (
        <div>
          <TextareaAutosize
            aria-label="empty textarea"
            disabled={props.disabled}
            minRows={3}
            maxLength={props.maxlen ? props.maxlen : maxLen}
            style={{ width: '100%' }}
            value={props.question.answer ? props.question.answer : ''}
            onChange={props.onChange}
          />
          <div style={{ fontSize: '14px' }}>
            Current: {props.question.answer ? props.question.answer.length : 0}{' '}
            Max: {maxLen}
          </div>
        </div>
      ) : null}
    </div>
  );
}
